// 导入 createRoot
import { createRoot } from "react-dom/client";
import router from "./router";

// 导入 App根组件
// import App from "./App";

import { RouterProvider } from "react-router-dom"
import React from "react";
import '@wk/components-react16/dist/all-no-ag-grid.min.css'
import '@/assets/design_iconfont/iconfont.js'
import '@/assets/design_iconfont/iconfont.css'
// 创建 root
const root = createRoot(document.querySelector("#root"));

// 调用 root 的render方法渲染
// root.render(<App />);
root.render(
    // <React.StrictMode>
        <RouterProvider router={router} />
    // </React.StrictMode>
);